import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  platforms: Types.Scalars['String']['input'];
  sensorName: Types.Scalars['String']['input'];
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly sensorExclusion?: { readonly __typename?: 'YalperSensorExclusion', readonly id: string } | null, readonly graphSensorChecks: ReadonlyArray<{ readonly __typename?: 'YalperGraphSensorCheck', readonly new: number, readonly old: number, readonly fixed: number, readonly collectedOn: string, readonly sensorName: string }>, readonly lastChecks: ReadonlyArray<{ readonly __typename?: 'YalperCheck', readonly checks: number, readonly cost: number, readonly found: number, readonly new: number, readonly sensor: { readonly __typename?: 'YalperSensor', readonly name: string, readonly platform: Types.YalperPlatform, readonly isError: boolean } }>, readonly report: { readonly __typename?: 'YalperReport', readonly items?: ReadonlyArray<{ readonly __typename?: 'YalperReportItem', readonly platform: Types.YalperPlatform, readonly account: string, readonly accountId: string, readonly campaign?: string | null, readonly campaignId?: string | null, readonly adGroup?: string | null, readonly adGroupId?: string | null, readonly ad?: string | null, readonly adId?: string | null, readonly sitelink?: string | null, readonly sitelinkId?: string | null, readonly keyword?: string | null, readonly keywordId?: string | null, readonly firstDate: string, readonly isNew: boolean, readonly maxLocationField: string, readonly objects: { readonly __typename?: 'YalperReportItemObjects', readonly analysisPeriod?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly bid?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly firstPageCpc?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly link?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly linkType?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly problemLink?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly host?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly date?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly spent?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly spentBefore?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly errwords?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly badWord?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly query?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly views?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly viewsBefore?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly ctr?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly ctrBefore?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly amountRemaining?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly averageSpend?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly viewsPerUser?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly targetLoc?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly clientLoc?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly campaignLoc?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly vcard?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly cardLoc?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly conversions?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly conversionsBefore?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly adTitle?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly adText?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly domainLoc?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly linkLoc?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly clicks?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly clicksBefore?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly utmParam?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly utmParamValue?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly limit?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly goalFullname?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly placement?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly comparisonPeriod?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly impressions?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly impressionsBefore?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly metric?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly metricDiff?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly metricDiffAbs?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly metricPreviousValue?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly metricValue?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly cpc?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly ratio?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null, readonly currencyCode?: { readonly __typename?: 'YalperReportItemObject', readonly name: string, readonly type: Types.YalperObjectType, readonly value: string } | null } }> | null } } | null } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($platforms: String!, $sensorName: String!, $startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      sensorExclusion(sensorName: $sensorName) {
        id
      }
      graphSensorChecks(startDate: $startDate, endDate: $endDate) {
        new
        old
        fixed
        collectedOn
        sensorName
      }
      lastChecks {
        checks
        cost
        found
        new
        sensor {
          name
          platform
          isError
        }
      }
      report(sensorNames: $sensorName, platforms: $platforms) {
        items {
          platform
          account
          accountId
          campaign
          campaignId
          adGroup
          adGroupId
          ad
          adId
          sitelink
          sitelinkId
          keyword
          keywordId
          firstDate
          isNew
          objects {
            analysisPeriod {
              name
              type
              value
            }
            bid {
              name
              type
              value
            }
            firstPageCpc {
              name
              type
              value
            }
            link {
              name
              type
              value
            }
            linkType {
              name
              type
              value
            }
            problemLink {
              name
              type
              value
            }
            host {
              name
              type
              value
            }
            date {
              name
              type
              value
            }
            spent {
              name
              type
              value
            }
            spentBefore {
              name
              type
              value
            }
            errwords {
              name
              type
              value
            }
            badWord {
              name
              type
              value
            }
            query {
              name
              type
              value
            }
            views {
              name
              type
              value
            }
            viewsBefore {
              name
              type
              value
            }
            ctr {
              name
              type
              value
            }
            ctrBefore {
              name
              type
              value
            }
            amountRemaining {
              name
              type
              value
            }
            averageSpend {
              name
              type
              value
            }
            viewsPerUser {
              name
              type
              value
            }
            targetLoc {
              name
              type
              value
            }
            clientLoc {
              name
              type
              value
            }
            campaignLoc {
              name
              type
              value
            }
            vcard {
              name
              type
              value
            }
            cardLoc {
              name
              type
              value
            }
            conversions {
              name
              type
              value
            }
            conversionsBefore {
              name
              type
              value
            }
            adTitle {
              name
              type
              value
            }
            adText {
              name
              type
              value
            }
            domainLoc {
              name
              type
              value
            }
            linkLoc {
              name
              type
              value
            }
            clicks {
              name
              type
              value
            }
            clicksBefore {
              name
              type
              value
            }
            utmParam {
              name
              type
              value
            }
            utmParamValue {
              name
              type
              value
            }
            limit {
              name
              type
              value
            }
            goalFullname {
              name
              type
              value
            }
            placement {
              name
              type
              value
            }
            comparisonPeriod {
              name
              type
              value
            }
            impressions {
              name
              type
              value
            }
            impressionsBefore {
              name
              type
              value
            }
            metric {
              name
              type
              value
            }
            metricDiff {
              name
              type
              value
            }
            metricDiffAbs {
              name
              type
              value
            }
            metricPreviousValue {
              name
              type
              value
            }
            metricValue {
              name
              type
              value
            }
            cpc {
              name
              type
              value
            }
            ratio {
              name
              type
              value
            }
            currencyCode {
              name
              type
              value
            }
          }
          maxLocationField
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      platforms: // value for 'platforms'
 *      sensorName: // value for 'sensorName'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;